/* eslint-disable */
import { http } from '@/helpers/http';
import { transformDateToSend, transformDateView } from '@/helpers/transformDates';

const defaultPromo = {
  id: 'new',
  is_active: false,
  title: '',
  residential_complex_id: null,
  subtitle: '',
  name: '',
  date_start: '',
  date_end: '',
  original_image: null,
  type: null,
};

export default {
  namespaced: true,
  state() {
    return {
      list: [], // Список акций
      search: '', // Поисковое слово в списке
      current: defaultPromo,
      types: [] // Типы акций
    };
  },

  mutations: {
    setList (state, shares) {
      state.list = shares.slice();
    },

    setSearch (state, data) {
      state.search = data;
    },

    setTypes (state, types) {
      state.types = types.slice();;
    },

    setValue (state, payload) {
      state.current = {
        ...state.current,
        ...payload
      }
    },

    clearCurrent (state) {
      state.current = {
        ...state.current,
        ...defaultPromo
      }
    },

    removeFormList (state) {
      const index = state.list.findIndex(({id}) => id === _id);
      state.list.splice(index, 1);
    },

    setCurrent (state, _id) {
      const promo = state.list.find(({ id }) => id === _id )
      state.current = {
        ...state.current,
        ...promo
      }
    },

    addList (state, current) {
      state.list.push({...current });
    }
  },

  getters: {
    getList: state => state.list
      .filter(({ title }) => title.toLowerCase().indexOf(state.search.toLowerCase()) >= 0)
      .map(({ id, title, residential_complex, updated_at_formatted, is_active }) => {
        return {
          id,
          title,
          is_active: is_active ? 'Да' : 'Нет',
          residential: residential_complex ? residential_complex.name : '',
          updated_at: updated_at_formatted
        };
      }),

    getById: state => _id => state.list.find(({ id }) => id === _id ),

    getCurrent: state => state.current,

    getTypes: state => state.types,
  },

  actions: {
    async getList({ commit }) {
      try {
        const { data } = await http.post('/admin/shares');
        console.log("data-List", data);
        commit('setList', data.shares);
        commit('setTypes', data.types);
      } catch (e) {
        throw e;
      }
    },

    async remove({ commit }, id) {
      await http.post('/admin/shares/remove', { id });
      commit('clearCurrent');
    },

    async getById({ commit }, id) {
      if (id === null || id === 'new') {
        commit('clearCurrent');
        return;
      }

      const { data } = await http.post('/admin/shares/edit', { id });

    //   commit('setTypes', data.types);
      //console.log('Data-share', { data });
      commit('setValue', {
        ...data.share,
        date_start: transformDateView(data.share.date_start),
        date_end: transformDateView(data.share.date_end),
      });
    },


    async save({ state }) {
      // Это новый элемент или редактирование?
      const isNew = state.current.id === 'new' || state.current.id === null;

      if (!isNew) {
        const { data: id } = await http.post('/admin/shares/store', {
          id: state.current.id,
          is_active: state.current.is_active,
          type: state.current.type,
          title: state.current.title,
          subtitle: state.current.subtitle,
          name: state.current.name,
          date_start: transformDateToSend(state.current.date_start),
          date_end: transformDateToSend(state.current.date_end),
          residential_complex_id: state.current.residential_complex_id,
          original_image: state.current.original_image,
        });
        return id;
      } else {
        const { data: id } = await http.post('/admin/shares/store', {
          is_active: state.current.is_active,
          type: state.current.type,
          title: state.current.title,
          subtitle: state.current.subtitle,
          name: state.current.name,
          date_start: transformDateToSend(state.current.date_start),
          date_end: transformDateToSend(state.current.date_end),
          residential_complex_id: state.current.residential_complex_id,
          original_image: state.current.original_image,
        });
        return id;
      }
    }
  },
};
